import { render } from "./sales-overview.vue?vue&type=template&id=4fd2844e"
import script from "./sales-overview.vue?vue&type=script&lang=js"
export * from "./sales-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__